// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Client lib imports
const airbrake = require('client/lib/airbrake')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const ErrorDetails = require('./details')
const ErrorPage = require('./page')

// This is the same check that React uses for production/development builds
const showErrors = process.env['NODE_ENV'] === 'development'

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { errors: [] }
    this.resetErrors = () => this.setState({ errors: [] })
  }

  componentDidCatch(error, info) {
    airbrake.notify({ error, params: { info } })
    this.setState({ errors: [ ...this.state.errors, error ] })
  }

  render() {
    if (this.state.errors.length) {
      return tag(ErrorPage, {
        onDismiss: showErrors ? this.resetErrors : null
      },
        showErrors && tag(ErrorDetails, {
          errors: this.state.errors
        })
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
}

module.exports = ErrorBoundary
